import actions from './actions'

const trackingOperations = {
  trackingInit: actions.trackingInit,
  trackEvent: actions.trackEvent,
  
}

export default trackingOperations
